import DiscoverMoreScreen from 'features/discoverMore/screens/DiscoverMoreScreen';
import React from 'react';

export default function DiscoverMore() {
  return <DiscoverMoreScreen />;
}
